import ShoppingBag from '../components/ShoppingBag';

const CartPage = () => {
  return (
    <div>
      <ShoppingBag />
    </div>
  );
};

export default CartPage;
